module.exports = __webpack_public_path__ + "img/children-dentristy-2.png";